import IndustryTechnology from "../assets/images/industry_technology.jpg";
import IndustryElectronics from "../assets/images/industry_electronics.png";
import IndustryHealthcare from "../assets/images/industry_healthcare_v2.jpg";
import IndustryChemicals from "../assets/images/industry_chemicals_v3.jpg";
import IndustryAutomotive from "../assets/images/industry_automotive_v5.png";
import IndustryManufacturing from "../assets/images/industry_manufacturing.jpg";
import IndustryConstruction from "../assets/images/industry_construction_v2.png";
import IndustryEnergy from "../assets/images/industry_energy_v3.jpg";
import IndustryWaterManagement from "../assets/images/industry_water_management.jpg";
import IndustryFoodBeverage from "../assets/images/industry_food_beverage_v4.png";
import IndustryAgriculture from "../assets/images/industry_agriculture_v3.jpg";
import IndustryConsumer from "../assets/images/industry_consumer_retail_v2.png";
import IndustryFinance from "../assets/images/industry_finance_v2.jpg";
import IndustryLogistics from "../assets/images/industry_logistics_v2.png";
import IndustryAerospace from "../assets/images/industry_aerospace_v2.jpg";
import IndustryMarine from "../assets/images/industry_marine_v2.jpg";
import IndustryMining from "../assets/images/industry_mining_v2.jpg";

export const STATIC_INDUSTRIES_MAP = {
  "Information & Communication Technology (ICT)": {
    name: "Information & Communication Technology (ICT)",
    image: IndustryTechnology,
    description:
      "Track artificial intelligence, cloud computing, cybersecurity, enterprise software, digital infrastructure, connectivity, data analytics, and emerging enterprise technologies.",
  },
  "Electronics & Semiconductors": {
    name: "Electronics & Semiconductors",
    image: IndustryElectronics,
    description:
      "Explore semiconductor technologies, electronic components, manufacturing equipment, advanced packaging, consumer electronics, and next-generation hardware innovation.",
  },
  "Healthcare & Pharmaceuticals": {
    name: "Healthcare & Pharmaceuticals",
    image: IndustryHealthcare,
    description:
      "Monitor healthcare innovation, pharmaceuticals, biotechnology, medical devices, diagnostics, digital health, and evolving regulatory landscapes.",
  },
  "Chemicals & Materials": {
    name: "Chemicals & Materials",
    image: IndustryChemicals,
    description:
      "Analyze specialty chemicals, advanced materials, polymers, coatings, adhesives, industrial gases, sustainable materials, and manufacturing innovation.",
  },
  "Automotive & Mobility": {
    name: "Automotive & Mobility",
    image: IndustryAutomotive,
    description:
      "Understand electric mobility, connected vehicles, autonomous technologies, automotive components, software-defined vehicles, and future transportation ecosystems.",
  },
  "Manufacturing & Industrial": {
    name: "Manufacturing & Industrial",
    image: IndustryManufacturing,
    description:
      "Gain insights into industrial automation, robotics, Industry 4.0, smart manufacturing, machinery, digital factories, and production technologies.",
  },
  "Construction & Infrastructure": {
    name: "Construction & Infrastructure",
    image: IndustryConstruction,
    description:
      "Explore construction materials, infrastructure development, smart buildings, engineering technologies, sustainable construction, and urban development.",
  },
  "Energy & Utilities": {
    name: "Energy & Utilities",
    image: IndustryEnergy,
    description:
      "Track renewable energy, hydrogen, battery storage, smart grids, conventional energy, utilities, and technologies driving the global energy transition.",
  },
  "Water & Environmental Services": {
    name: "Water & Environmental Services",
    image: IndustryWaterManagement,
    description:
      "Research water treatment, wastewater management, recycling, pollution control, environmental technologies, resource management, and circular economy solutions.",
  },
  "Food & Beverage": {
    name: "Food & Beverage",
    image: IndustryFoodBeverage,
    description:
      "Track food ingredients, processing technologies, functional foods, beverages, food safety, packaging innovation, and evolving consumer preferences.",
  },
  Agriculture: {
    name: "Agriculture",
    image: IndustryAgriculture,
    description:
      "Understand precision agriculture, agri-tech, crop protection, biological inputs, smart farming, agricultural machinery, and sustainable farming practices.",
  },
  "Consumer Goods and Retail": {
    name: "Consumer Goods and Retail",
    image: IndustryConsumer,
    description:
      "Evaluate consumer behavior, FMCG, retail transformation, personal care, e-commerce, omnichannel retail, private labels, and brand innovation.",
  },
  "Banking, Financial Services, and Insurance (BFSI)": {
    name: "Banking, Financial Services, and Insurance (BFSI)",
    image: IndustryFinance,
    description:
      "Monitor banking, insurance, fintech, digital payments, wealth management, embedded finance, regulatory technologies, and financial innovation.",
  },
  "Logistics, Transportation & Supply Chain": {
    name: "Logistics, Transportation & Supply Chain",
    image: IndustryLogistics,
    description:
      "Explore freight, warehousing, transportation, ports, cold chain, fleet management, supply chain technologies, and logistics transformation.",
  },
  "Aerospace and Defense": {
    name: "Aerospace and Defense",
    image: IndustryAerospace,
    description:
      "Track commercial aviation, defense technologies, space systems, unmanned platforms, aerospace manufacturing, avionics, and defense modernization.",
  },
  "Marine & Maritime": {
    name: "Marine & Maritime",
    image: IndustryMarine,
    description:
      "Research commercial shipping, shipbuilding, offshore industries, port infrastructure, marine technologies, coastal development, and the blue economy.",
  },
  "Mining & Metals": {
    name: "Mining & Metals",
    image: IndustryMining,
    description:
      "Explore mining operations, critical minerals, metal processing, battery materials, steel, aluminum, copper, rare earth elements, and sustainable resource development.",
  },
};

export const STATIC_INDUSTRIES_ORDER = Object.keys(STATIC_INDUSTRIES_MAP).sort();

/**
 * Returns the normalized URL slug for an industry key
 */
export const slugifyIndustry = (industryKey) => {
  return industryKey
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/-+/g, "-")
    .replace(/^-+/, "")
    .replace(/-+$/, "");
};

/**
 * Finds the actual backend key from a slug
 */
export const findIndustryKeyBySlug = (slug, fetchedHierarchy) => {
  // Aliases for common slugs mapped to our static keys
  const aliases = {
    logistics: "logistics-transportation-supply-chain",
    ict: "information-communication-technology-ict",
    bfsi: "banking-financial-services-and-insurance-bfsi",
  };
  const targetSlug = aliases[slug] || slug;

  const allKeys = Object.keys(fetchedHierarchy || {});
  let found = allKeys.find((key) => slugifyIndustry(key) === targetSlug);
  if (!found) {
    const staticKeys = Object.keys(STATIC_INDUSTRIES_MAP);
    found = staticKeys.find((key) => slugifyIndustry(key) === targetSlug);
  }
  return found;
};

/**
 * Gets the industry details (name, image, description, subcategories)
 */
export const getIndustryDetails = (industryKey, fetchedHierarchy) => {
  const subCategories =
    (fetchedHierarchy && fetchedHierarchy[industryKey]) || [];

  if (STATIC_INDUSTRIES_MAP[industryKey]) {
    return {
      ...STATIC_INDUSTRIES_MAP[industryKey],
      name: industryKey,
      slug: slugifyIndustry(industryKey),
      subCategories,
    };
  }

  // Fallback to matching by slug
  const targetSlug = slugifyIndustry(industryKey);
  const staticKey = Object.keys(STATIC_INDUSTRIES_MAP).find(
    (k) => slugifyIndustry(k) === targetSlug,
  );

  if (staticKey) {
    return {
      ...STATIC_INDUSTRIES_MAP[staticKey],
      name: industryKey, // Keep the backend name
      slug: targetSlug,
      subCategories,
    };
  }

  return {
    name: industryKey,
    image: IndustryTechnology, // Fallback
    description: `The global ${industryKey} industry is one of the most dynamic and encompassing sectors of the modern economy. Ongoing technological advancements, infrastructure development, and increased consumer demand are driving this sector toward a continuous growth trajectory. Explore our comprehensive market insights, competitive landscapes, and the latest trends to stay ahead in the ${industryKey} market.`,
    slug: targetSlug,
    subCategories,
  };
};
